












































































import { Meta } from "@/store/meta"
import { Vue, Component } from "vue-property-decorator"
import { Server } from '@/store/server'
import { getModule } from "vuex-module-decorators"
@Component({
})
export default class ConfigSent extends Vue {
  get meta() {
    return getModule(Meta)
  }
  get server() {
    return getModule(Server)
  }
}
